import { render, staticRenderFns } from "./NewScheduleEvent.vue?vue&type=template&id=afd81fe2&"
import script from "./NewScheduleEvent.vue?vue&type=script&lang=js&"
export * from "./NewScheduleEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports